export const FRAMER_MOTION_TOKEN_SELECT_EASING = [0.34, 0.94, 0.1, 1]

export const HYPERCORE_CHAIN_ID = 'evm:hyperliquid'
export const HYPEREVM_CHAIN_ID = 'evm:999'
